import axiosBackEnd from "../../config/axios/axios-back-end";

// Self service - get all property contacts
const getAllPropertyContacts = async () => {
  const response = await axiosBackEnd.get(
    "/api/onboarding/property-contacts/",
  );
  return response.data;
};

// Self service - get property contact by username
const getPropertyContactByUserName = async (username) => {
  const response = await axiosBackEnd.get(
    `/api/onboarding/property-contacts/by-username/${username}`,
  );
  return response.data;
};


// Self service - get property contact
const getPropertyContact = async (propertyContact) => {
  const response = await axiosBackEnd.get(
    `/api/onboarding/property-contacts/${propertyContact}`,
  );
  return response.data;
};

// Self service - get property contacts by customer
const getPropertyContactByProperty = async (customerId) => {
  const response = await axiosBackEnd.get(
    `/api/onboarding/property-contacts/by-customer/${customerId}`,
  );
  return response.data;
};

// Self service - ceate property contacts
const createPropertyContact = async (data) => {
  const res = await axiosBackEnd.post(
    `/api/onboarding/property-contacts`,
    data,
  );
  return res.data;
};

// Self service - update property contacts
const updatePropertyContact = async (data) => {
  const res = await axiosBackEnd.put(
    `/api/onboarding/property-contacts/${data._id}`,
    data,
  );
  return res.data;
};

const getAllPropertyContactsWithProperty = async (data) => {
  const res = await axiosBackEnd.post(
    `/api/onboarding/property-contacts/with-property`,
    data,
  );
  return res.data;
};

export {
  getPropertyContact,
  getAllPropertyContacts,
  getPropertyContactByProperty,
  createPropertyContact,
  updatePropertyContact,
  getAllPropertyContactsWithProperty,
  getPropertyContactByUserName,
};
